export default {
	name: "eiis-button",
  props: ['name', 'type', 'icon', 'text', 'tooltip', 'href', 'event'],
  data: function () {
    return {
      styles: function () {
        return {
          cursor: 'pointer',
          marginLeft: '6px'
        }
      }
    }
  },
  methods: {
    onClick: function (event) {
			console.log("doing button onClick", event);
			if (event.type == "click" && this.href) {
				document.location.href = this.href;
			}
      if (this.event) {
        this.$emit(this.event, event.target.value)
			}
    }
  }, 
  template: `
    <button v-bind:id=name class="btn"
        v-bind:class=type
		    v-bind:title=tooltip
        v-bind:aria-describedby={name}
        v-on:click="onClick"
      >
			<div id="buttonicon" v-bind:style="styles"></div>
				{{text}}
        <slot></slot>
		</button>
  `
}
